// **React Imports
import { memo, useMemo } from 'react'

// **Components Imports
import { Box, Tooltip, Typography } from '@mui/material'
import Icon from '../icon'

// **Hooks Imports
import useDemoUser from '../../hooks/useDemoUser'

// **Style Imports
import { ENVIRONMENT } from '../../env/env'
import './styles.css'

const DemoBanner = () => {
  // ** hooks
  const { isDemoUser, isDemoTenant } = useDemoUser()

  // ** variables
  const content = useMemo(() => {
    return isDemoTenant
      ? 'You are viewing a read-only demo. Mutating actions are disabled.'
      : 'You have readonly access. Mutating actions are disabled.'
  }, [isDemoTenant])

  const signupUrl = useMemo(() => {
    return ENVIRONMENT === 'DEV'
      ? 'https://dev.coderscout.io/signup'
      : 'https://app.coderscout.io/signup'
  }, [])

  if (!isDemoUser) return null

  return (
    <Box
      className="demo-banner-container"
      role="status"
      aria-label="Demo mode active"
    >
      <Tooltip title={content} arrow>
        <Box className="demo-banner-left">
          <Box className="demo-banner-badge">
            <Icon icon="mdi:alert-outline" className="demo-badge-icon" />
            <Typography className="demo-banner-badge-text">
              DEMO MODE
            </Typography>
          </Box>
          <Typography className="demo-banner-desc">{content}</Typography>
        </Box>
      </Tooltip>

      <Box className="demo-banner-right">
        {isDemoTenant && (
          <Box className="demo-banner-ctas">
            <a
              href="https://www.coderscout.io/"
              rel="noreferrer"
              className="demo-btn demo-btn-outline"
              style={{ textDecoration: 'none' }}
            >
              <Icon icon="ic:round-arrow-back" />
              Go back to website
            </a>
            <a
              href={signupUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="demo-btn demo-btn-contained"
              style={{ textDecoration: 'none' }}
            >
              <Icon icon="mdi:lightning-bolt" />
              Try free trial
            </a>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default memo(DemoBanner)
